<template>
  <table class="table mt-0 mb-0 full-width">
    <thead class="bg-light">
      <tr>
        <th scope="col" class="border-0 pr-0" style="width: 40px;">
          <d-checkbox
            class="mb-0 pr-0"
            v-model="selectAll" />
        </th>
        <th scope="col" class="border-0">{{ $t('ui.name') }}</th>
        <th scope="col" class="border-0 text-center">{{ $t('marketing.listGenerationDate') }}</th>
        <th scope="col" class="border-0 text-right">{{ $t('marketing.maxCustomersTable') }}</th>
        <th scope="col" class="border-0 text-right">{{ $t('marketing.filtersCount') }}</th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="(segment, index) of segments"
        :key="'segment-' + index">
        <td class="align-middle pr-0">
          <d-checkbox
            class="mb-0 pr-0"
            :value="segment.id"
            v-model="selectedIds"
            @change="emitSelection" />
        </td>
        <td class="align-middle">
          {{ segment.name }}
        </td>
        <td class="align-middle text-center">
          {{ segment.list_generated_at }}
        </td>
        <td class="align-middle text-right">
          {{ segment.customers_limit }}
        </td>
        <td class="align-middle text-right">
          {{ segment.filters_count }}
        </td>
      </tr>
      <tr v-if="segments.length === 0">
        <td
          colspan="5"
          class="text-center">
          {{ $t('marketing.noSegmentsToDisplay') }}&hellip;
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: 'mailing-segments-table',
  props: {
    segments: {
      default: () => [],
      type: Array
    },
    value: {
      default: () => [],
      type: Array
    }
  },
  data () {
    return {
      selectedIds: [...this.value]
    };
  },
  computed: {
    selectAll: {
      get () {
        return this.segments.length > 0 && this.selectedIds.length === this.segments.length;
      },
      set (value) {
        if (value) {
          this.selectedIds = this.segments.map(segment => segment.id);
        } else {
          this.selectedIds = [];
        }
        this.emitSelection();
      }
    }
  },
  watch: {
    value (newValue) {
      this.selectedIds = [...newValue];
    }
  },
  methods: {
    emitSelection () {
      this.$nextTick(() => {
        this.$emit('input', this.selectedIds);
      });
    }
  }
};
</script>
